import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from './data-access/toast-selectors';
import { clearToast } from './data-access/toast-reducer';
import './Toasts.css';

const isErrorTitle = (title: string) => {
  const t = (title || '').toLowerCase();
  return (
    t.includes('error') ||
    t.includes('failed') ||
    t.includes('rejection') ||
    t.includes('missing') ||
    t.includes('validation') ||
    t.includes('duplicate')
  );
};

export const ToastsContainer = () => {
  const toastData = useSelector(showToast);
  const dispatch = useDispatch();
  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      dispatch(clearToast());
      setIsExiting(false);
    }, 200);
  };

  useEffect(() => {
    if (!toastData?.showToast) return;
    const duration = isErrorTitle(toastData.title || '') ? 8000 : 4000;
    const t = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => dispatch(clearToast()), 200);
    }, duration);
    return () => clearTimeout(t);
  }, [toastData?.showToast, toastData?.title, dispatch]);

  if (!toastData?.showToast) return null;

  const isError = isErrorTitle(toastData.title || '');

  return (
    <div className="toast-custom-container">
      <div
        className={`toast-custom ${isError ? 'toast-custom-error' : ''} ${isExiting ? 'toast-custom-out' : ''}`}
        role="alert"
      >
        <div className="toast-custom-icon">
          {isError ? <FontAwesomeIcon icon={faExclamationCircle} /> : <FontAwesomeIcon icon={faCheck} />}
        </div>
        <div className="toast-custom-body">
          <p className="toast-custom-title">{toastData.title}</p>
          {toastData.message && <p className="toast-custom-message">{toastData.message}</p>}
        </div>
        <button type="button" className="toast-custom-close" onClick={handleClose} aria-label="Close">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};
